<template>
  <div id="app" v-bind:class="{'home':routeHome}">
    <!-- Nav -->
    <div class="c-loading__mask2"></div>
    <div class="c-loading__mask"></div>
    <div class="c-loading__line"></div>
    <div class="c-loading__line-container" v-bind:class="{'c-loading-line--visible': loadingLine}">
      <h1 class="c-loading__line-text">{{loadingText}}.</h1>
    </div>
    <div id="loader" class="c-loading">
      <div class="c-loading__container">
        <h1 class="c-loading__countdown">{{ counter.count }}%</h1>
      </div>
      <!-- <img class="c-loading__logo" src="/assets/logoMark.svg" /> -->
      <div class="c-loading__container-logo">
        <svg
          class="c-loading__logo"
          xmlns="http://www.w3.org/2000/svg"
          style="overflow:visible"
          viewBox="0 0 72.3 48"
        >
          <title>Asset 1</title>
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <!-- A -->
              <path
                class="c-loading__letter"
                stroke="#000000"
                stroke-width="0"
                stroke-miterlimit="10"
                fill="#000000"
                fill-opacity="0"
                d="M72,10.94C71.24-.8,56.65,0,56.65,0H45.59V48H56.65s15.61.43,15.61-15.29C72.26,28.65,72.45,19,72,10.94ZM56.85,47.61H47.56A1.6,1.6,0,0,1,46,45.87V1.75S46,.4,47.76.4h9.09S65.74,0,66.13,12.2s.2,18.77.2,19.35C66.33,32.33,66.93,47.61,56.85,47.61Z"
              />
              <!-- D -->
              <path
                class="c-loading__letter"
                stroke="#000000"
                stroke-width="0"
                stroke-miterlimit="10"
                fill="#000000"
                fill-opacity="0"
                d="M40.45,0,35.51,7.92,12.12,44.64a6.33,6.33,0,0,1-5.41,3,6.27,6.27,0,0,1-6.33-6.2A6,6,0,0,1,.49,40.3,2,2,0,0,1,1,39.38a1.52,1.52,0,0,1,.31-.22,1.72,1.72,0,0,1,.4-.14,1.37,1.37,0,0,1,.61,0,1.2,1.2,0,0,1,.58.46c.62.7,3.11.5,3.76-.75a2,2,0,0,0,.19-1.07c-.2-1.94-2.37-1.94-2.77-1.94S1.17,35.81.15,40l0,.17h0s0,.09,0,.16a5.77,5.77,0,0,0-.1,1.1A6.65,6.65,0,0,0,6.71,48a6.68,6.68,0,0,0,5.72-3.14l0,0,0-.06h0l12.42-19.5c.78-1.13,1.56-1.13,1.56-1.13H37.52a1,1,0,0,1,1,.93V46.45a1.2,1.2,0,0,1-.94,1.15H32.75s0,.38,0,.39H44.21V0Zm-2,22.9a.91.91,0,0,1-.92.9H26.82s-.79,0-.65-.53l.52-.81c1.47-2.18,8.1-12.69,10.06-15.79l.67-1.06A.59.59,0,0,1,38.48,6Z"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>

    <div class="container">
      <div class="c-head" v-bind:class="{'c-head--black':menuOpen, 'c-head--shop': sectionShop}">
        <div class="c-head__section"></div>
        <div class="c-head__section">
          <router-link to="/">
            <img class="c-head__logo" alt="artful-dodgers-logo" src="/assets/logoMark.svg" />
          </router-link>
        </div>
        <div class="c-head__section">
          <div
            class="c-menu__select-wrapper"
            v-bind:class="{'c-menu__select-wrapper--push':cart.length > 0}"
          >
            <v-select
              v-model="selectedCurrency"
              label="text"
              value="value"
              :searchable="false"
              :clearable="false"
              :options="currencies"
            ></v-select>
          </div>
          <a v-if="cart.length > 0" href v-on:click="toggleCart($event)" class="c-cart__btn">
            <p class="c-cart__qtyHeader">CART ({{ cart.length }})</p>
            <i class="c-cart__icon">
              <img src="../assets/tempShoppingCart2.svg" alt="shopping cart icon" />
            </i>
          </a>
        </div>
      </div>
    </div>
    <div
      class="app-container"
      v-bind:style="{'min-height': menuHeight, 'height': cartHeight }"
      data-v-bind:class="{ 'app-container--open': menuOpen }"
    >
      <OffcanvasMenu ref="menu" @toggleMenu="toggleMenu" />
      <RingSize ref="ringSize" />

      <Cart ref="cart" v-bind:cart="cart" />
      <Order
        ref="order"
        v-bind:cart="cart"
        v-if="showCheckout"
        v-bind:class="{'c-cart--payment--open':showCheckout}"
      />
      <div
        class="app"
        v-bind:class="{'app--menu-open':menuAppOpen}"
        v-bind:style="{'min-height':minHeight + 'px'}"
      >
        <transition
          @beforeLeave="beforeLeave"
          @enter="enter"
          @afterEnter="afterEnter"
          name="fade"
          mode="out-in"
        >
          <router-view></router-view>
        </transition>
      </div>
    </div>

    <div class="c-footer" v-bind:class="{'c-footer--shop': sectionShop}">
      <div class="c-footer__socialLinks">
        <a
          href="https://www.facebook.com/Artful-Dodgers-312263936206812"
          class="c-footer__socialLink"
          target="_blank"
          rel="noopener"
        >
          <i class="c-footer__socialIcon c-footer__socialIcon--fb"></i>
        </a>
        <a
          href="https://www.behance.net/artfuldodgers"
          target="_blank"
          rel="noopener"
          class="c-footer__socialLink"
        >
          <i class="c-footer__socialIcon c-footer__socialIcon--be"></i>
        </a>
        <a
          href="https://www.instagram.com/artfuldodgersnz/"
          target="_blank"
          rel="noopener"
          class="c-footer__socialLink"
        >
          <i class="c-footer__socialIcon c-footer__socialIcon--insta"></i>
        </a>
      </div>
      <div id="socialBar" class="c-footer__socialBar"></div>

      <div class="c-footer__linkSection">
        <div class="c-footer__links c-footer__links--left">
          <router-link to="/shop" class="c-footer__link">
            <p class="c-footer__link-text">Shop</p>
          </router-link>
          <router-link to="/contact" class="c-footer__link">
            <p class="c-footer__link-text">Contact</p>
          </router-link>
          <router-link to="/termsandconditions" class="c-footer__link">
            <p class="c-footer__link-text">Terms & Conditions</p>
          </router-link>
        </div>
        <div class="c-footer__links c-footer__links--right">
          <router-link to="/shippingandreturns" class="c-footer__link">
            <p class="c-footer__link-text">Shipping</p>
          </router-link>
          <router-link to="/privacypolicy" class="c-footer__link">
            <p class="c-footer__link-text">Privacy Policy</p>
          </router-link>
          <router-link to="/shippingandreturns" class="c-footer__link">
            <p class="c-footer__link-text">Returns</p>
          </router-link>
        </div>
      </div>

      <span class="c-footer__copyRight">&#169; Artful Dodgers Ltd.</span>
      <span
        class="c-footer__byLine"
      >Seasoned, sous vide, sauteed and served by Leo Gardiner & Andrei Rotar</span>
    </div>
  </div>
</template>

<script>
import OffcanvasMenu from "./OffcanvasMenu.vue";
import Cart from "./Cart.vue";
import Order from "./Order.vue";
import RingSize from "./RingSize.vue";
var imagesLoaded = require("imagesloaded");

export default {
  name: "app",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Artful Dodgers",
    // all titles will be injected into this template
    titleTemplate: "%s | Artful Dodgers",
  },
  data: function () {
    return {
      selectedCurrency: "",
      menuOpen: false,
      menuAppOpen: false,
      initLoad: false,
      loadAbout: false,
      minHeight: 0,
      menuHeight: 0,
      sectionShop: false,
      loadingLine: false,
      cartHeight: "auto",
      routeHome: false,
      sectionProduct: false,
      loadingText: "MODERN CLASSICS",
      counter: {
        count: 0,
      },
      cart: [],
      showCheckout: false,
      currencies: [
        { text: "USD", value: "USD" },
        { text: "GBP", value: "GBP" },
        { text: "EUR", value: "EUR" },
        { text: "NZD", value: "NZD" },
        { text: "AUD", value: "AUD" },
      ],
    };
  },
  methods: {
    beforeLeave: function () {},
    enter: function () {
      var self = this;
      if (this.$refs.menu.menuCanOpen != true) {
        self.initLoad = false;
        TweenMax.to($(".c-loading__line"), 0.6, {
          scaleX: 1,
          ease: Power2.easeOut,
        });
        if (
          this.$route.name == "shop" ||
          this.$route.name.includes("product") ||
          this.$route.name == "about"
        ) {
          this.loadingText = "MODERN CLASSICS";
          this.loadingText = this.$route.name.includes("product")
            ? "TIMELESS STYLE"
            : "MODERN CLASSICS";
          setTimeout(function () {
            TweenMax.fromTo(
              $(".c-loading__line-text"),
              0.2,
              { opacity: 0 },
              { opacity: 1 }
            );
            TweenMax.fromTo(
              $(".c-loading__line-text"),
              0.2,
              { x: -200 },
              { x: 0, ease: Power2.easeOut }
            );
            setTimeout(function () {
              self.initLoad = true;
            }, 600);
          }, 200);
        } else {
          setTimeout(function () {
            $(".c-loading__line").css("transform-origin", "right");
            TweenMax.to($(".c-loading__line"), 0.3, {
              scaleX: 0,
              ease: Power2.easeOut,
            });
            setTimeout(function () {
              $(".c-loading__line").css("transform-origin", "left");
              setTimeout(function () {
                self.initLoad = true;
              }, 600);
            }, 300);
          }, 400);
        }
      } else {
        self.initLoad = false;
        var checkMenuAnim = setInterval(function () {
          if (!self.$refs.menu.menuCanOpen) {
            if (
              self.$route.name == "shop" ||
              self.$route.name.includes("product") ||
              self.$route.name == "about"
            ) {
              if (self.$route.name == "about") {
                $(".c-loading__line").css("background", "#fff");
                $(".c-loading__line-text").css("color", "#fff");
              }

              $(".c-loading__line").css("transform-origin", "left");
              TweenMax.to($(".c-loading__line"), 0.6, {
                scaleX: 1,
                ease: Power2.easeOut,
              });
              self.loadingText = "MODERN CLASSICS";
              self.loadingText = self.$route.name.includes("product")
                ? "TIMELESS STYLE"
                : "MODERN CLASSICS";
              setTimeout(function () {
                TweenMax.fromTo(
                  $(".c-loading__line-text"),
                  0.2,
                  { opacity: 0 },
                  { opacity: 1 }
                );
                TweenMax.fromTo(
                  $(".c-loading__line-text"),
                  0.2,
                  { x: -200 },
                  { x: 0, ease: Power2.easeOut }
                );
                setTimeout(function () {
                  self.initLoad = true;
                }, 600);
              }, 200);
            }
            clearInterval(checkMenuAnim);
          }
        });
      }
    },
    afterEnter: function () {
      // if (this.$route.name != "shop" && !this.$route.name.includes("product")){
      //   setTimeout(function(){
      //     cpmsp;e
      //     $('.c-loading__line').css('transform-origin','right');
      //     TweenMax.to($('.c-loading__line'), 0.6, {scaleY:1, ease:Power2.easeOut})
      //     setTimeout(function(){
      //       $('.c-loading__line').css('transform-origin','left');
      //     }, 600)
      //   }, 700)
      // }
    },
    toggleCart: function (event) {
      event.preventDefault();
      this.$refs.cart.toggleCart();
      this.calcCartHeight(this.$refs.cart.cartOpen);
    },
    calcCartHeight: function (cartOpen) {
      var mobile = window.matchMedia("(max-width: 650px)");
      var self = this;
      if (mobile.matches) {
        setTimeout(function () {
          if (cartOpen) {
            var cartHeight = $(".js-cart").height();
            self.cartHeight = cartHeight + 70 + "px";
          } else {
            self.cartHeight = "auto";
          }
        }, 50);
      }
    },
    toggleRingGuide: function (isOpening) {
      this.calcSizeGuide(isOpening);
      this.$refs.ringSize.toggleSizeGuide();
    },
    calcSizeGuide: function (isOpening) {
      var mobile = window.matchMedia("(max-width: 650px)");
      var self = this;
      if (mobile.matches) {
        setTimeout(function () {
          if (isOpening) {
            var cartHeight = $(".c-cart--size").height();
            self.cartHeight = cartHeight + 70 + "px";
          } else {
            self.cartHeight = "auto";
          }
        }, 50);
      }
    },
    closeOrder: function () {
      this.showCheckout = false;
      this.minHeight = 0;
    },
    completeOrder: function () {
      this.showCheckout = false;
      this.$refs.cart.toggleCart();
    },
    toggleMenu: function (val) {
      var self = this;
      var menuColumns = window.matchMedia("(max-width: 590px)");
      this.menuOpen = val;
      if (menuColumns.matches) {
        if (val) {
          this.checkMenuHeight();
        } else {
          this.menuHeight = "calc(100vh - 147px)";
        }
      }
      if (val) {
        self.menuAppOpen = true;
        if (this.$refs.cart.cartOpen) {
          this.$refs.cart.toggleCart();
          this.calcCartHeight(false);
        }
      } else {
        //wait for menu anim
        setTimeout(function () {
          self.menuAppOpen = false;
        }, 1400);
      }
      if (this.showCheckout) {
        this.closeOrder();
      }
      this.menuAnimation();
    },
    openOrderForm: function () {
      this.showCheckout = true;
      var self = this;
      setTimeout(function () {
        self.checkHeight($("#payment-form").height() + 200);
      }, 100);
    },
    checkMenuHeight: function () {
      var menuHeight = $(".c-menu__offcanvas").height();
      this.menuHeight = menuHeight + "px";
    },
    checkHeight: function (minheight) {
      var x = window.matchMedia("(max-width: 610px)");
      if (x.matches) {
        this.minHeight = minheight + 300;
      } else {
        this.minHeight = minheight + 200;
      }
    },
    menuAnimation: function () {
      var footerBar = $("#socialBar");
      TweenMax.to(footerBar, 0.1, { opacity: 0, scaleX: 0 });
      setTimeout(function () {
        TweenMax.to(footerBar, 0, { opacity: 1 });
        TweenMax.to(footerBar, 1.3, { scaleX: 1, ease: Power3.easeOut });
      }, 100);
    },
    menuChangeAnimation: function () {
      this.$refs.menu.toggleMenu();
    },
  },
  watch: {
    currencyChange: function (newVal, oldval) {
      var self = this;
      if (self.selectedCurrency.value != newVal) {
        self.selectedCurrency = { text: newVal, value: newVal };
      }
    },
    selectedCurrency: function (newVal) {
      if (newVal.value != this.$store.state.currency) {
        this.$store.commit("updateCurrency", newVal.value);
      }
    },
    cartContents(newCount, oldCount) {
      this.cart = newCount;
    },
    $route(to, from) {
      var self = this;
      this.loadAbout = true;
      if (this.$route.name == "home") {
        self.routeHome = true;
        $("body").addClass("re-loaded");
        var checkExist = setInterval(function () {
          //ANIMATION
          if ($(".c-2d").length) {
            clearInterval(checkExist);
            if (Modernizr.touchevents) {
              $("body").addClass("body--black");
              setTimeout(function () {
                $("body").removeClass("re-loaded");
              }, 1500);
            } else {
              self.initLoad = true;
              window.homePage();
              $("body").addClass("body--black");
              setTimeout(function () {
                $("body").removeClass("re-loaded");
              }, 100);
            }
          }
        }, 100);
      } else {
        self.routeHome = false;
        $("body").removeClass("body--black");
      }
      if (
        this.$route.name == "shop" ||
        this.$route.name.includes("product") ||
        this.$route.name == "about"
      ) {
        this.sectionShop = true;
        this.loadingLine = true;
      } else {
        this.sectionShop = false;
        this.loadingLine = false;
      }

      if (this.menuOpen) {
        this.menuChangeAnimation();
      }
      if (this.showCheckout) {
        this.closeOrder();
      }
    },
  },
  mounted() {
    console.log(
      "%c SOUS VIDE, SAUTEED, SEASONED AND SERVED BY LEO GARDINER 🤙",
      "background: #000; color: #fff; font-size:24px; text-align:center; font-weight:bold; border: 5px solid #fff"
    );
    console.log(
      "%c leo.gardiner@artfuldodgers.co.nz",
      "background: #fff; color: #000; font-size:12px; text-align:center;"
    );
    this.selectedCurrency = this.$store.state.currency;
    var vm = this;
    $(document).ready(function () {
      var letters = $(".c-loading__letter");
      letters.each(function (i, e) {
        var length = e.getTotalLength();
        $(e).css("stroke-dasharray", e.getTotalLength());
        $(e).css("stroke-dashoffset", e.getTotalLength());
        $(e).css("stroke-width", 0.2);
      });

      if (vm.$route.name == "home" || vm.$route.name == "about") {
        vm.loadAbout = false;
        $("body").addClass("body--black");

        if (vm.$route.name == "home") {
          vm.routeHome = true;
        }
      } else {
        $("body").removeClass("body--black");
      }
      if (vm.$route.name == "shop" || vm.$route.name.includes("product")) {
        vm.sectionShop = true;
        vm.loadingLine = true;
      } else {
        vm.sectionShop = false;
        vm.loadingLine = false;
      }

      imagesLoaded(document.querySelector("body"), function (instance) {
        var lettersReversed = [];
        lettersReversed[0] = letters[1];
        lettersReversed[1] = letters[0];
        TweenMax.staggerTo(
          lettersReversed,
          1.85,
          { "stroke-dashoffset": 30, ease: Power4.easeInOut },
          0.8
        );
        setTimeout(function () {
          TweenMax.staggerTo(
            lettersReversed,
            0.5,
            { "fill-opacity": 1, ease: Power1.easeOut },
            0.2
          );
          TweenMax.to(percentage, 0.4, { opacity: 0, ease: Power2.easeOut });
          setTimeout(function () {
            TweenMax.to($(".c-loading__logo"), 0.4, {
              opacity: 0,
              ease: Power2.easeOut,
            });
          }, 500);
        }, 1700);
        var current = vm.counter;

        TweenMax.to(current, 2.2, {
          count: 100,
          onUpdate: function () {
            vm.counter.count = Math.ceil(current.count);
          },
          ease: Power1.easeInOut,
        });

        TweenMax.to($(".c-loading__mask"), 2, {
          scaleX: 1,
          ease: Power2.easeInOut,
        });
        var percentage = $(".c-loading__countdown");
        TweenMax.to(percentage, 1.9, {
          y: 10,
          opacity: 1,
          ease: Power4.easeOut,
        });

        setTimeout(function () {
          TweenMax.to(percentage, 0.4, { opacity: 0, ease: Power2.easeIn });
        }, 1750);

        setTimeout(function () {
          //HOMEPAGE
          if (vm.$route.name == "home" || vm.$route.name == "about") {
            if (vm.$route.name == "home") {
              vm.initLoad = true;
            } else {
            }
            TweenMax.to($(".c-loading__mask"), 1.15, {
              top: "0%",
              height: "100vh",
              ease: Power4.easeOut,
            });

            $("#loader").addClass("c-loading--loaded");
            setTimeout(function () {
              TweenMax.to($(".c-footer"), 0.75, {
                scaleY: 1,
                ease: Power2.easeOut,
              });
              $("body").addClass("all-loaded");
              vm.initLoad = true;
              setTimeout(function () {
                $("#loader").remove();

                var footerLinks = $(".c-footer__link");
                var l = $(".c-footer__socialIcon").length;
                TweenMax.staggerTo($(".c-footer__socialIcon"), 0.7, {
                  y: 0,
                  opacity: 1,
                  cycle: {
                    delay: function (i) {
                      return Math.abs(Math.floor(l / 2) - i) * 0.1;
                    },
                  },
                });
                var footerBar = $("#socialBar");
                TweenMax.to(footerBar, 1, { scaleX: 1 });
                TweenMax.to(footerLinks, 0.3, {
                  opacity: 1,
                  ease: Power1.easeOut,
                });

                setTimeout(function () {
                  $("body").addClass("loading-over");
                }, 1000);
              }, 600);
            }, 750);
          } else {
            $("#loader").addClass("c-loading--loaded");
            TweenMax.to($(".c-loading__line"), 0.6, {
              scaleX: 1,
              ease: Power2.easeOut,
            });
            if (
              vm.$route.name == "shop" ||
              vm.$route.name.includes("product")
            ) {
              vm.loadingText = "MODERN CLASSICS";
              vm.loadingText = vm.$route.name.includes("product")
                ? "TIMELESS STYLE"
                : "MODERN CLASSICS";
              setTimeout(function () {
                TweenMax.fromTo(
                  $(".c-loading__line-text"),
                  0.2,
                  { opacity: 0 },
                  { opacity: 1 }
                );
                TweenMax.fromTo(
                  $(".c-loading__line-text"),
                  0.2,
                  { x: -200 },
                  { x: 0, ease: Power2.easeOut }
                );
              }, 1);
            } else {
              TweenMax.fromTo(
                $(".c-loading__line-text"),
                0.2,
                { opacity: 0 },
                { opacity: 1 }
              );
              TweenMax.fromTo(
                $(".c-loading__line-text"),
                0.2,
                { x: -200 },
                { x: 0, ease: Power2.easeOut }
              );
              $(".c-loading__line").css("transform-origin", "right");
              TweenMax.to($(".c-loading__line"), 0.6, {
                scaleX: 0,
                ease: Power2.easeOut,
              });
            }

            setTimeout(function () {
              TweenMax.to($(".c-footer"), 0.75, {
                scaleY: 1,
                ease: Power2.easeOut,
              });

              $("body").addClass("all-loaded");

              setTimeout(function () {
                $("#loader").remove();
                var footerLinks = $(".c-footer__link");
                var l = $(".c-footer__socialIcon").length;
                TweenMax.staggerTo($(".c-footer__socialIcon"), 0.7, {
                  y: 0,
                  opacity: 1,
                  cycle: {
                    delay: function (i) {
                      return Math.abs(Math.floor(l / 2) - i) * 0.1;
                    },
                  },
                });
                var footerBar = $("#socialBar");
                TweenMax.to(footerBar, 1, { scaleX: 1 });
                TweenMax.to(
                  footerLinks,
                  1,
                  { opacity: 1, ease: Power2.easeOut },
                  0.1
                );
                vm.initLoad = true;

                setTimeout(function () {
                  $("body").addClass("loading-over");
                }, 1000);
              }, 600);
            }, 1000);
          }
        }, 2500);
      });
    });
  },
  computed: {
    cartContents() {
      return this.$store.state.cart;
    },
    currencyChange() {
      return this.$store.state.currency;
    },
  },
  components: {
    OffcanvasMenu,
    Cart,
    Order,
    RingSize,
  },
};
</script>


// WEBPACK FOOTER //
// App.vue?e37d8a14